module.exports = __webpack_public_path__ + "img/title_4.1c123a5e.png";